export default __webpack_public_path__ + "ee619ac7b490043d8728bc8ab2efb318.glb";